import React from 'react';
import { Text4 } from '../../../styles';
import { printRupee } from '../../../app_methods';
import moment from 'moment';
import { Badge, Icon, Button, Tooltip } from 'antd';
import { APPROVAL_FLOW_STATUS_TYPES } from '../../../constants';
import { PermissionHoc } from '../../HOC';

const WritePermissableButton = PermissionHoc(Button,"APPROVAL_FLOW_WRITE",{ is_component: true, fallbackComponent: null })
const ReadPermissableButton = PermissionHoc(Button,"APPROVAL_FLOW_READ",{ is_component: true, fallbackComponent: null })

export const getTransfersApprovalTableColumns = (methods) => [{
    title: "Created At",
    key: "created_at",
    render: (record) => <Text4>{moment(record.created_at).format("lll")}</Text4>
}, {
    title: "URN",
    key: "unique_request_number",
    render: (record) => <Text4>{record.transfer_request? record.transfer_request.unique_request_number: '---'}</Text4>
}, {
    title: "Transfer Amount",
    key: "amount",
    render: (record) => <Text4>{printRupee(record.amount)}</Text4>
},
{
    title: "Requested By",
    key: "requested_by",
    render: (record) => <Text4>{record.requested_by}</Text4>
},
{
    title: <span className="c-pointer" onClick={methods.setShowStatusInfoDrawer}><span>Status</span><Icon style={{ fontSize: 14 }} className="ml-1" type="info-circle" /></span>,
    key: "status",
    render: (record) =>
        <div>
            {
                <div>
                    <Badge color={APPROVAL_FLOW_STATUS_TYPES[record.status].color} text={<Text4>{APPROVAL_FLOW_STATUS_TYPES[record.status].label}</Text4>} />
                </div>
            }
        </div>
},
{
    title: "Approval",
    key: "status",
    render: (record) =>
        <div>
            {record.approvals_required.map(level =>{
                return <Text4 style={{marginRight: 10}}>{record.approved_levels.includes(level)?
                    <Tooltip title="Approved" className="mr-1"><Icon type="check-circle" style={{color: 'green'}} /></Tooltip>:
                    record.declined_levels.includes(level)?<Tooltip title="Rejected" className="mr-1"><Icon type="close-circle" style={{color: 'red'}}/></Tooltip>:
                    <Tooltip title="Pending for approval" className="mr-1"><Icon type="exclamation-circle" style={{color: 'orange'}}/></Tooltip>}{level}</Text4>
            }

            )}
        </div>
},
{
    title: "Actions",
    render: (record) => <>
        {
        record.status == 'approved' || record.status == 'rejected' || record.status == 'cancelled' || methods.isMerchant ?'---':
        !record.approved_levels.includes(methods.user_level)  && !record.declined_levels.includes(methods.user_level) ?
        <>
        <WritePermissableButton type="primary" className="mr-1" size="small" onClick={() => methods.approveRequest({ ...record },false)} ghost>Approve</WritePermissableButton>
        <WritePermissableButton type="danger" className="mr-1" size="small" onClick={() => methods.approveRequest({ ...record }, true)} ghost>Reject</WritePermissableButton>
        </>
        : '---'
        }
    </>
}
];

export const transfersApprovalTableFilterNodes = () => {
    return [{
        label: "Created At",
        field: "created_at",
        placeholder: "Select Transfer Date",
        inputType: "date_range",
        defaultValue: [moment().subtract(3, 'days'), moment()],
        preventClear: true
    }, {
        label: "URN",
        field: "urn",
        placeholder: "Enter URN",
        inputType: "text",
        defaultValue: ""
    }, {
        label: "Status",
        field: "status",
        placeholder: "Select Status",
        inputType: "select",
        defaultValue: undefined,
        options: Object.keys(APPROVAL_FLOW_STATUS_TYPES).map((type, index) => {
            let object = {};
            object.key = index;
            object.value = type;
            object.label = <Badge color={APPROVAL_FLOW_STATUS_TYPES[type].color} text={<Text4>{APPROVAL_FLOW_STATUS_TYPES[type].label}</Text4>} />;
            return object;
        })
    }];
}
